import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

interface Detail { PersonType: number; jobCategory: number | null; isAlternative: boolean; physcianId: string | null; PhyAvailId: string | null; employeeId: string | null; EmpAvailId: number | null; }

export interface sessionCreationDto{
         sessionId?:number,
         sessionName:string,
         sessionType:number,
         sessionDescription:string,
         sessionStartDate:string,
         sessionEndDate:string,
         sessionCapacity:number,
         isTenantive:boolean,
         isConfirmed:boolean,
         organizationId:number,
         tenantId:string,
         branchId:string,
         createdDate:Date,
         createdBy:number,
         updatedBy:null,
         createdIP:null,
         updatedIP:null,
         updatedDate:null,
         applicationType:number,
         villageId:number,
         locationId:number,
         sessionStatus:number,
         ashaWorkerId:number,
         employeeId:number,
         convertedDate:Date,
         sessionDetDto?:Detail[]
}





export abstract class VopdData {
    abstract getById<type>(url: string,params?:HttpParams): Observable<type>;
    abstract list<returnType>(url: string,params?:HttpParams): Observable<returnType>;
    abstract create<type,returnType>(url: string, data:type,params?:HttpParams): Observable<returnType>;
    abstract update<type,returnType>(url: string, data: type,params?:HttpParams): Observable<returnType>;
}